import { isAxiosError } from 'axios'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import * as ProgramRest from '@app/domain/program/program.rest'
import type { AppAction, AppState } from '@app/state'

import * as ProgramScreenState from './state'

import type { AxiosResponse} from 'axios';

function* loadProgram(action: AppAction) {
  if (action.type === ProgramScreenState.ActionType.LoadProgram) {
    const appState: AppState = yield select((a) => a)
    try {
      const request = ProgramRest.getProgram(action.programId)
      const response: AxiosResponse<ProgramRest.IGetProgramResponse> =
        yield call(request, appState.config.apiLocation, appState.auth.token)

      if (response.status === 200) {
        yield put(
          ProgramScreenState.actions.loadProgramSucceeded(
            response.data.program,
          ),
        )
      } else {
        yield put(ProgramScreenState.actions.loadProgramFailed())
      }
    } catch (e) {
      yield put(ProgramScreenState.actions.loadProgramFailed())
    }
  }
}

export function* handleLoadProgram() {
  yield takeEvery(ProgramScreenState.ActionType.LoadProgram, loadProgram)
}

function* updateProgram(action: AppAction) {
  if (action.type === ProgramScreenState.ActionType.UpdateProgram) {
    const appState: AppState = yield select((a) => a)
    try {
      const request = ProgramRest.updateProgram(action.program)
      const response: AxiosResponse<ProgramRest.IUpdateProgramResponse> =
        yield call(request, appState.config.apiLocation, appState.auth.token)

      if (
        response.status === 200 &&
        ProgramRest.isIUpdateProgramSuccessResponse(response.data)
      ) {
        yield put(
          ProgramScreenState.actions.updateProgramSucceeded(
            response.data.program,
          ),
        )
      } else if (ProgramRest.isIUpdateProgramErrorResponse(response.data)) {
        yield put(
          ProgramScreenState.actions.updateProgramFailed(
            response.data.error ?? 'Error creating program',
          ),
        )
      }
    } catch (e) {
      if (isAxiosError(e)) {
        const responseData = e.response?.data
        if (ProgramRest.isIUpdateProgramErrorResponse(responseData)) {
          yield put(
            ProgramScreenState.actions.updateProgramFailed(
              responseData.error ?? 'Error updating program',
            ),
          )
        } else {
          yield put(
            ProgramScreenState.actions.updateProgramFailed(
              'Error updating program',
            ),
          )
        }
      } else {
        yield put(
          ProgramScreenState.actions.updateProgramFailed(
            'Error updating program',
          ),
        )
      }
    }
  }
}

export function* handleUpdateProgram() {
  yield takeEvery(ProgramScreenState.ActionType.UpdateProgram, updateProgram)
}

export const sagas = {
  handleUpdateProgram,
  handleLoadProgram,
}
